/**
 * @enum FieldRenderType These all are the types which are supported in Dynamic Form Renderer
 */
enum FieldRenderType {
  URL = "URL",
  DATE = "DATE",
  DATE_TIME = "DATE_TIME",
  RADIO = "RADIO",
  PHONE = "PHONE",
  EMAIL = "EMAIL",
  MONEY = "MONEY",
  CHECK_BOX = "CHECK_BOX",
  MULTI_SELECT = "MULTI_SELECT",
  SINGLE_SELECT = "SINGLE_SELECT",
  MULTI_LINE_TEXTFIELD = "MULTI_LINE_TEXTFIELD",
  SINGLE_LINE_TEXTFIELD = "SINGLE_LINE_TEXTFIELD",
  INTEGER = "INTEGER",
  MM_DD = "MM_DD",
  IMAGE = "IMAGE",
  ORGANIZATION_NAME = "ORGANIZATION_NAME",
  NESTED_MULTI_SELECT = "NESTED_MULTI_SELECT",
  COMMUNITY_SPONSOR = "COMMUNITY_SPONSOR",
  BULK_TICKET_QUANTITY = "BULK_TICKET_QUANTITY",
  HTML = "HTML",
  DIVISION = "DIVISION",
  SECTION_SEPARATOR = "SECTION_SEPARATOR",
  MULTI_LINE_TEXTFIELD_HTML_INPUT = "MULTI_LINE_TEXTFIELD_HTML_INPUT",
  URL_WITH_ICON = "URL_WITH_ICON",
  MULTI_FILE = "MULTI_FILE",
  PRIVATE_MULTI_FILE = "PRIVATE_MULTI_FILE",
  MULTI_IMAGE = "MULTI_IMAGE",
  SINGLE_IMAGE = "SINGLE_IMAGE",
  SINGLE_IMAGE_WITH_ASPECT_RATIO = "SINGLE_IMAGE_WITH_ASPECT_RATIO",
  TAGS = "TAGS",
  SOCIAL_MEDIA_GROUP = "SOCIAL_MEDIA_GROUP", // this is used only on UI to group and show social media links
  COLOR = "COLOR", // this is used only in UI to show color selected
  PASSWORD = "PASSWORD", // this is used only in UI to show dots as in password field instead of value
  EMAIL_LIST = "EMAIL_LIST",

  ORGANIZATION_LEVEL = "ORGANIZATION_LEVEL",
  LABEL_WITH_ACTION = "LABEL_WITH_ACTION" // this is used only in UI to show label with link
}

export const OptionsDependentRenderFieldType = [
  FieldRenderType.RADIO,
  FieldRenderType.SINGLE_SELECT,
  FieldRenderType.MULTI_SELECT
];

export const MinMaxLengthValidationRenderFieldTypeList = [
  FieldRenderType.SINGLE_LINE_TEXTFIELD,
  FieldRenderType.MULTI_LINE_TEXTFIELD,
  FieldRenderType.URL,
  FieldRenderType.EMAIL,
  FieldRenderType.NESTED_MULTI_SELECT,
  FieldRenderType.ORGANIZATION_NAME,
  FieldRenderType.INTEGER,
  FieldRenderType.MONEY,
  FieldRenderType.MULTI_SELECT,
  FieldRenderType.PHONE,
  FieldRenderType.MULTI_IMAGE,
  FieldRenderType.MULTI_FILE,
  FieldRenderType.PRIVATE_MULTI_FILE,
  FieldRenderType.URL_WITH_ICON,
  FieldRenderType.TAGS
];

export const PlaceholderAllowedRenderFieldTypeList = [
  FieldRenderType.DATE,
  FieldRenderType.DATE_TIME,
  FieldRenderType.EMAIL,
  FieldRenderType.INTEGER,
  FieldRenderType.MONEY,
  FieldRenderType.MULTI_LINE_TEXTFIELD,
  FieldRenderType.ORGANIZATION_NAME,
  FieldRenderType.PHONE,
  FieldRenderType.SINGLE_LINE_TEXTFIELD,
  FieldRenderType.SINGLE_SELECT,
  FieldRenderType.URL,
  FieldRenderType.URL_WITH_ICON
];

export const RenderFieldTypeAllowedForValidationSchema = [
  FieldRenderType.EMAIL,
  FieldRenderType.INTEGER,
  FieldRenderType.MONEY,
  FieldRenderType.MULTI_LINE_TEXTFIELD,
  FieldRenderType.ORGANIZATION_NAME,
  FieldRenderType.SINGLE_LINE_TEXTFIELD,
  FieldRenderType.URL,
  FieldRenderType.URL_WITH_ICON,
  FieldRenderType.PHONE
];

export const RenderFieldTypeAllowedForShowHideSchema = [
  FieldRenderType.SINGLE_SELECT,
  FieldRenderType.RADIO,
  FieldRenderType.MULTI_SELECT,
  FieldRenderType.NESTED_MULTI_SELECT,
  FieldRenderType.INTEGER,
  FieldRenderType.MONEY,
  FieldRenderType.DATE,
  FieldRenderType.DATE_TIME,
  FieldRenderType.EMAIL,
  FieldRenderType.SINGLE_LINE_TEXTFIELD,
  FieldRenderType.MULTI_LINE_TEXTFIELD,
  FieldRenderType.CHECK_BOX
];

export const TextRenderFieldTypeList = [
  FieldRenderType.EMAIL,
  FieldRenderType.MULTI_LINE_TEXTFIELD,
  FieldRenderType.ORGANIZATION_NAME,
  FieldRenderType.SINGLE_LINE_TEXTFIELD,
  FieldRenderType.URL,
  FieldRenderType.URL_WITH_ICON
];

export const CanAddDefaultValueForRenderTypeList = [
  FieldRenderType.CHECK_BOX,
  FieldRenderType.DATE,
  FieldRenderType.DATE_TIME,
  FieldRenderType.EMAIL,
  FieldRenderType.INTEGER,
  FieldRenderType.MM_DD,
  FieldRenderType.MONEY,
  FieldRenderType.MULTI_LINE_TEXTFIELD,
  FieldRenderType.MULTI_SELECT,
  FieldRenderType.RADIO,
  FieldRenderType.SINGLE_LINE_TEXTFIELD,
  FieldRenderType.SINGLE_SELECT,
  FieldRenderType.URL,
  FieldRenderType.URL_WITH_ICON,
  FieldRenderType.PHONE
];

export const CanBeFormattedRenderTypeList = [FieldRenderType.INTEGER, FieldRenderType.MONEY];

export const CanHaveDifferentOptionViewType = [FieldRenderType.RADIO, FieldRenderType.MULTI_SELECT];

export const MultipleSelectionsAllowedRenderTypeList = [
  FieldRenderType.MULTI_SELECT,
  FieldRenderType.NESTED_MULTI_SELECT
];

export const CreateConflictNotRequiredRenderTypeList = [
  FieldRenderType.HTML,
  FieldRenderType.SECTION_SEPARATOR,
  FieldRenderType.MULTI_FILE,
  FieldRenderType.PRIVATE_MULTI_FILE,
  FieldRenderType.MULTI_IMAGE,
  FieldRenderType.SINGLE_IMAGE,
  FieldRenderType.SINGLE_IMAGE_WITH_ASPECT_RATIO,
  FieldRenderType.TAGS
];

export const IndentNotRequiredRenderTypeList = [FieldRenderType.SECTION_SEPARATOR];

export const DefaultFullWidthRenderTypeList = [
  FieldRenderType.TAGS,
  FieldRenderType.MULTI_FILE,
  FieldRenderType.PRIVATE_MULTI_FILE,
  FieldRenderType.NESTED_MULTI_SELECT,
  FieldRenderType.MULTI_SELECT,
  FieldRenderType.MULTI_IMAGE,
  FieldRenderType.SINGLE_IMAGE,
  FieldRenderType.SINGLE_IMAGE_WITH_ASPECT_RATIO,
  FieldRenderType.HTML,
  FieldRenderType.IMAGE,
  FieldRenderType.MULTI_LINE_TEXTFIELD,
  FieldRenderType.MULTI_LINE_TEXTFIELD_HTML_INPUT,
  FieldRenderType.RADIO,
  FieldRenderType.CHECK_BOX,
  FieldRenderType.SECTION_SEPARATOR
];

export const FieldRenderTypePIIList = [
  FieldRenderType.EMAIL,
  FieldRenderType.PHONE,
  FieldRenderType.SINGLE_LINE_TEXTFIELD,
  FieldRenderType.MULTI_LINE_TEXTFIELD,
  FieldRenderType.URL,
  FieldRenderType.URL_WITH_ICON,
  FieldRenderType.INTEGER,
  FieldRenderType.MONEY,
  FieldRenderType.DATE,
  FieldRenderType.DATE_TIME,
  FieldRenderType.SINGLE_SELECT,
  FieldRenderType.MULTI_SELECT,
  FieldRenderType.NESTED_MULTI_SELECT,
  FieldRenderType.RADIO
];

export const FieldIconRequiredRenderTypeList = [FieldRenderType.URL_WITH_ICON];

export const IconNotRequiredRenderTypeList = [FieldRenderType.SECTION_SEPARATOR];

export default FieldRenderType;

export const MultipleValuesForDisplayProfile = [
  FieldRenderType.MULTI_SELECT,
  FieldRenderType.NESTED_MULTI_SELECT,
  FieldRenderType.SOCIAL_MEDIA_GROUP
];

export const MultipleResourceObjectsForDisplayProfile = [
  FieldRenderType.MULTI_FILE,
  FieldRenderType.PRIVATE_MULTI_FILE,
  FieldRenderType.MULTI_IMAGE
];

export const SingleResourceObjectForDisplayProfile = [FieldRenderType.SINGLE_IMAGE];

export const HideEmptyValueInDisplayProfile = [FieldRenderType.SECTION_SEPARATOR, FieldRenderType.HTML];

export const AllowedRenderTypesWithNoValueInDisplayProfile = [FieldRenderType.SECTION_SEPARATOR, FieldRenderType.HTML];

export const CanApplyRegexValidationRenderTypeList = [
  FieldRenderType.SINGLE_LINE_TEXTFIELD,
  FieldRenderType.MULTI_LINE_TEXTFIELD,
  FieldRenderType.EMAIL
];
